{
  "account": {
    "title": "Mein Konto",
    "list": {
      "title": "Konten",
      "description": "Liste der verknüpften Kontenrechnungen"
    },
    "form": {
      "name": {
        "title": "Name",
        "description": "Ihr Kontoname"
      },
      "password": {
        "title": "Passwort",
        "description": "Legen Sie ein neues Passwort für Ihr Konto fest, lassen Sie es leer, um das aktuelle Passwort zu behalten"
      },
      "emailPreferences": {
        "title": "E-Mail-Einstellungen",
        "description": "E-Mail-Benachrichtigungstypen auswählen"
      }
    },
    "billing": "Details zur Abrechnung",
    "subscriptions": "Abonnements",
    "manageSubscription": "Abonnement verwalten",
    "popup": {
      "downgrade": "Möchten Sie wirklich downgraden? Die Herabstufung wird sofort wirksam.<br/>Bitte beachten Sie, dass Sie für die verbleibende Zeit des aktuellen Abrechnungszeitraums keinen Anspruch auf einen Rabatt haben.<br/>Der neue Planpreis wird im nächsten Abrechnungszeitraum angewendet.",
      "default": "Sind Sie sicher, dass Sie Ihren Plan ändern möchten?",
      "cancel": "Möchten Sie Ihr Abonnement wirklich kündigen?<br/> Ihre Website wird bis zum Ende Ihres aktuellen Abonnementzeitraums weiterhin übersetzt. Danach wird die Übersetzung deaktiviert.<br/> Bitte beachten Sie, dass Sie für den nicht genutzten Zeitraum keinen Anspruch auf eine Rückerstattung haben.",
      "resume": "Möchten Sie Ihr Abonnement wirklich wieder aufnehmen?"
    }
  },
  "ai_translation": {
    "header": "KI-Übersetzung",
    "plan": {
      "header": "Preise für KI-Übersetzungen",
      "used": "Sie haben in Ihren AI-Credits {words_used} / {words_allowed} übersetzte Wörter verwendet.",
      "remaining": "Verfügbare KI-Credits:",
      "words": "Wörter",
      "add_more_credits": "Fügen Sie weitere KI-Credits hinzu",
      "details": {
        "idiomatic_expressions": "Idiomatische und technische Ausdrücke",
        "background_translation": "Übersetzungen im Hintergrund",
        "page_context": "Seiten- und Website-Kontext für die Übersetzung",
        "perfect_quality": "Perfekte Qualität, günstiger Preis",
        "no_recurring": "Keine wiederkehrende Zahlung, im Voraus bezahltes Kontingent",
        "save_40": "Sparen Sie 40 % im Vergleich zum 20-Dollar-Plan",
        "save_50": "Sparen Sie 50 % im Vergleich zum 20-Dollar-Plan",
        "best_website": "Website, die eine perfekte Übersetzungsqualität erfordert"
      },
      "quota": "{estimated_words} Wörter ~ {estimated_pages} Seiten"
    },
    "settings": {
      "banner": {
        "title": "Linguise AI-Übersetzung",
        "intro": "Linguise freut sich, Linguise AI Translation vorzustellen, eine neue Premium-Funktion, die KI-LLM-Modelle (die neuesten, für Übersetzungsaufgaben optimierten Modelle von Llama) nutzt. Entwickelt für Websites, die höchste Genauigkeit erfordern, berücksichtigt Linguise sowohl den Seiten- als auch den gesamten Website-Kontext und sorgt so für unvergleichliche Ergebnisse. Bieten Sie Ihren Kunden höchste Übersetzungsqualität und stellen Sie sicher, dass ihre Botschaft in jeder Sprache perfekt ankommt.",
        "button": "Jetzt upgraden"
      },
      "alert": {
        "description": "Diese Funktion ist in Ihrem aktuellen Plan nicht enthalten und muss separat erworben werden. Aktivieren Sie dieses Add-on, um alle unten aufgeführten Optionen freizuschalten."
      },
      "languages": {
        "title": "KI-Übersetzung auf Sprachen anwenden",
        "description": "Wählen Sie eine bestimmte Sprache aus, in der die KI-Übersetzung angewendet werden soll"
      },
      "button": {
        "save": "Einstellungen speichern"
      },
      "form": {
        "rule_application": {
          "description": "Wenden Sie die KI-Übersetzung auf statischen oder dynamischen Inhalt oder beides an",
          "title": "Auf Inhalt anwenden",
          "all": "Alle Inhalte",
          "static": "Statischer Inhalt",
          "dynamic": "Dynamischer Inhalt"
        },
        "website_topic": {
          "title": "Website-Thema",
          "placeholder": "Sushi-Restaurant...",
          "description": "Definieren Sie das Thema Ihrer Website für eine bessere Übersetzungsqualität (z. B. Rechtliches, Sushi-Restaurant, E-Shop für Fahrradteile usw.).\nBitte geben Sie das Website-Thema auf Englisch ein."
        },
        "apply_to_urls": {
          "title": "Auf URLs anwenden",
          "description": "Wählen Sie bestimmte URLs aus, auf die die KI-Übersetzung angewendet werden soll",
          "all_urls": "Alle URLs",
          "selected_urls": "Ausgewählte URLs",
          "label": "URL zur Bewerbung",
          "placeholder": "URL zur Bewerbung",
          "wildcard": "Platzhalter",
          "regex": "Regulärer Ausdruck",
          "add": "Neu hinzufügen",
          "expression": "Ausdruckstyp"
        },
        "apply_languages": {
          "title": "Auf Sprachen anwenden",
          "description": "Wählen Sie eine bestimmte Sprache aus, in der die KI-Übersetzung angewendet werden soll",
          "all_languages": "Alle Sprachen",
          "selected_languages": "Ausgewählte Sprachen",
          "placeholder": "Sprachen auswählen...",
          "feedback": "Sie müssen eine Sprache auswählen"
        },
        "enable_mode": {
          "title": "KI-ÜBERSETZUNG AKTIVIEREN",
          "description": "Wählen Sie aus, wie die KI-Übersetzung aktiviert werden soll.\nEs gelten nur die folgenden Regeln.\n Nur der Live-Editor ermöglicht die Aktivierung der Übersetzung seitenweise aus der Live-Editor-Ansicht.\n Regeln und Live-Editor verwenden beide Funktionen.",
          "disabled": "Deaktiviert",
          "rules": "Nur Regeln",
          "live_editor": "Nur Live-Editor",
          "all": "Regeln und Live-Editor"
        },
        "formality": {
          "title": "Formalität",
          "description": "Geben Sie den Grad der Formalität in Übersetzungen an, der möglicherweise für Zielgruppen und Kontexte wichtig ist.\nNeutral versucht, die Formalität des Originalinhalts beizubehalten.\nFormal steht für professionelle, geschäftliche oder juristische Inhalte (z. B. die Verwendung formeller Pronomen wie „usted“ im Spanischen).\nInformell steht für zwanglose, umgangssprachliche Inhalte (z. B. die Verwendung von \"tú\" im Spanischen).",
          "neutral": "Neutral",
          "formal": "Formell",
          "informal": "Informell"
        },
        "sentence_structure": {
          "classic": "Klassiker",
          "short": "Kurze und prägnante Sätze",
          "detailed": "Ausführliche und erklärende Sätze",
          "title": "Satzstruktur",
          "description": "Definieren Sie den bevorzugten Schreibstil."
        },
        "content_purpose": {
          "marketing": "Marketing/Werbung (überzeugender, ansprechender Ton)",
          "technical": "Technisch/indukativ (klar, präzise, ​​handlungsorientiert)",
          "support": "Kundensupport (einfühlsam, hilfsbereit, beruhigend)",
          "legal": "Rechtlich/Compliance (präzise, ​​formal, eindeutig)",
          "educational": "Lehrreich (klar, strukturiert, zugänglich)",
          "title": "Inhaltlicher Zweck",
          "description": "Definieren Sie den funktionalen Zweck des zu übersetzenden Inhalts.",
          "other_placeholder": "Beschreiben Sie den Zweck...",
          "other": "Sonstiges (auf Englisch)"
        },
        "target_audience": {
          "title": "Zielgruppe",
          "description": "Angabe der Zielgruppe des übersetzten Inhalts (auf Englisch).",
          "placeholder": "z. B. spanischsprachige Eltern, EU-Datenschutzbeauftragte"
        },
        "advanced": {
          "title": "Erweiterte KI-Anweisungen",
          "description": "Erweiterte KI-Anweisungen"
        },
        "override_default_translations": {
          "title": "Standardübersetzung überschreiben",
          "description": "Wenn diese Option auf JA gesetzt ist, wird der Inhalt per KI (Linguise AI) übersetzt, selbst wenn er bereits mit Cloud AI (Standardübersetzungsmodell) übersetzt wurde."
        },
        "force_replace_before": {
          "title": "KI-Neuübersetzung erzwingen",
          "description": "Übersetze mit KI alle Inhalte erneut, deren KI-Übersetzung vor dem ausgewählten Datum erstellt wurde, zum Beispiel Inhalte, die mit einem älteren Modell übersetzt wurden. Die Neuübersetzung erfolgt beim nächsten Besuch der betroffenen Seiten gemäß den Regeln und verbraucht deine KI-Credits.",
          "before_date": "Vor einem Datum"
        },
        "model": {
          "current": "Aktuell",
          "title": "Modell",
          "description": "Wählen Sie das LLM-Übersetzungsmodell aus, das Sie verwenden möchten",
          "load_error": "Verfügbare Modelle konnten nicht geladen werden. Bitte versuchen Sie es später erneut.",
          "thinking_warning": "Dieses Modell verwendet ein hohes Maß an Schlussfolgerungsvermögen (\"Denken\") und verbraucht deutlich mehr Token pro Übersetzung."
        },
        "override_manual_and_selected": {
          "no_default": "Nein (Standard)",
          "title": "Manuelle und ausgewählte Übersetzungen überschreiben",
          "description": "Standardmäßig bleibt eine manuell bearbeitete Übersetzung auf Ihrer Website erhalten, auch wenn eine KI-optimierte Übersetzung erzeugt wurde. Wählen Sie JA, um stattdessen die KI-optimierte Übersetzung anzuzeigen. Ihre manuellen Übersetzungen bleiben gespeichert und Sie können jederzeit zurückwechseln. Dies gilt auch, wenn Sie die Seiten erneut übersetzen, um neue Übersetzungen zu erhalten; dabei wird automatisch die neueste verwendet."
        }
      },
      "message": {
        "save_success": "Von den aktuell bereits übersetzten Inhalten beträgt die Anzahl der Seiten, die durch KI-Übersetzung verbessert werden könnten, etwa {{ai_affected_urls}}.",
        "save_success_only": "Einstellungen erfolgreich gespeichert."
      }
    },
    "pricing": {
      "plan": {
        "title": "KI-Übersetzungskontingent bestellen",
        "buy_button": "KI-ÜBERSETZUNGSPAKET KAUFEN"
      },
      "modal": {
        "title": "Planänderung bestätigen",
        "description": "Möchten Sie Ihren KI-Übersetzungsplan wirklich ändern?",
        "button_cancel": "Stornieren",
        "button_confirm": "Bestätigen",
        "loading": "Bitte warten...",
        "amount": "Menge",
        "credit": "Kredit",
        "total_due": "Gesamtbetrag"
      },
      "comparison": {
        "title": "Google Cloud AI-Übersetzung vs. Linguise AI-Übersetzung",
        "list": {
          "0": {
            "google": "Schnelle und zuverlässige Übersetzungen",
            "linguise": "Umgang mit idiomatischen und technischen Ausdrücken"
          },
          "1": {
            "google": "Sofortige Übersetzungen aller Webseiten",
            "linguise": "Generierung der Übersetzungen im Hintergrund"
          },
          "2": {
            "google": "Beste Qualität, niedriger Preis",
            "linguise": "Perfekte Qualität, günstiger Preis"
          },
          "3": {
            "google": "Am besten geeignet für große Websites oder geringes Budget",
            "linguise": "Am besten für Websites geeignet, die eine perfekte Übersetzungsqualität erfordern"
          },
          "4": {
            "google": "Seitenkontext für die Übersetzung",
            "linguise": "Seiten- und Website-Kontext für die Übersetzung"
          }
        }
      },
      "botom_banner": {
        "title": "Erleben Sie unübertroffene Übersetzungsgenauigkeit mit dem",
        "sub_title": "Neue Linguise-KI-Übersetzung",
        "description": "Linguise erweitert seine automatischen Übersetzungsdienste mit der Einführung von Linguise AI Translation, einer leistungsstarken neuen Option, die modernste KI-Übersetzung (LLM) nutzt (aktuelle, für Übersetzungen optimierte Llama-Modelle). Diese Erweiterung bietet Website-Entwicklern und Webagenturen eine noch höhere Übersetzungsqualität – ideal für Projekte, bei denen Perfektion an erster Stelle steht. Linguise AI Translation ergänzt unsere bestehende, hochwertige Google Cloud AI-Übersetzung und bietet Ihnen mehr Flexibilität und Präzision."
      }
    },
    "success": {
      "tab_title": "Vielen Dank für den Kauf des AI Translation-Plans!",
      "title": "Vielen Dank für den Kauf des AI Translation-Plans!",
      "subtitle": "Ihr KI-Übersetzungsplan wurde erfolgreich gekauft!",
      "message": "Sie können Ihren KI-Übersetzungsplan auf der Einstellungsseite für die KI-Übersetzung verwalten.",
      "home": "KI-Übersetzung verwalten"
    }
  },
  "billing": {
    "form": {
      "name": {
        "title": "Name",
        "description": "Name des Abrechnungskontos"
      },
      "phone": {
        "title": "Telefon",
        "description": "Telefon des Abrechnungskontos"
      },
      "email": {
        "title": "E-Mail",
        "description": "E-Mail des Abrechnungskontos"
      },
      "address": {
        "title": "Adresse",
        "description": "Adresse des Abrechnungskontos",
        "city": "Stadt",
        "country": "Land",
        "address1": "Adresse 1",
        "address2": "Adresse 2",
        "postal": "Postleitzahl",
        "state": "Bundesland"
      },
      "tax": {
        "title": "Steuernummer"
      }
    }
  },
  "checkouts": {
    "header": "Kasse",
    "payment_method": "Wählen Sie Zahlungsmethode",
    "stripe_card": "Kreditkarte (Stripe)",
    "paypal": "PayPal",
    "address": {
      "new": "Geben Sie eine neue Rechnungsadresse ein",
      "existing": "Vorhandene Adresse verwenden"
    },
    "pay_stripe": "bestätigen und bezahlen",
    "terms": "Durch die Bestätigung Ihres Abonnements gestatten Sie Linguise, Ihnen künftige Zahlungen gemäß unseren Bedingungen in Rechnung zu stellen. Sie können Ihr Abonnement jederzeit kündigen.",
    "coupon": {
      "title": "Haben Sie einen Gutschein?",
      "placeholder": "Geben Sie hier Ihren Gutscheincode ein",
      "apply": "Anwenden",
      "percent": "{{0}} % Rabatt"
    },
    "add_new": "Neu hinzufügen",
    "use_existing": "Bestehende Zahlungsmethode verwenden",
    "recurring": {
      "month_single": "Wird monatlich abgerechnet",
      "month_many": "Wird alle {{count}} Monate in Rechnung gestellt",
      "year_single": "Jährliche Abrechnung",
      "year_many": "Wird alle {{count}} Jahre in Rechnung gestellt",
      "day_single": "Tägliche Abrechnung",
      "day_many": "Wird alle {{count}} Tage in Rechnung gestellt",
      "week_single": "Wöchentliche Abrechnung",
      "week_many": "Wird alle {{count}} Wochen in Rechnung gestellt"
    },
    "add_new_no_stripe": "Neue Karte hinzufügen",
    "summary": {
      "title": "Zusammenfassung",
      "subtotal": "Zwischensumme",
      "total": "Gesamt"
    }
  },
  "dashboard": {
    "main": {
      "title": "Dashboard"
    },
    "statistics": {
      "main_title": "Statistik der letzten 30 Tage",
      "characters": "Übersetzte Zeichen",
      "words": "Übersetzte Wörter",
      "bandwidth": "Eingangs-Bandbreite",
      "request": "Anfragen",
      "page_views": "Seitenaufrufe pro Sprache (letzte 30 Tage)",
      "multilingual_views": "Mehrsprachige Seitenaufrufe (letzte 30 Tage)",
      "most_page_viewed": "20 Meist angesehene Seiten (letzte 30 Tage)",
      "no_data_yet": "Noch keine Daten verfügbar",
      "th_language": "Sprache",
      "th_page_views": "Seitenansichten",
      "real_visitors": "Echte Besucher",
      "crawler": "Webcrawler"
    },
    "planHints": {
      "subscribeButton": "Abonnieren",
      "upgradeButton": "Tarif hochstufen",
      "usedWords": "Sie haben derzeit {words_used} Wörter",
      "noPlan": "Kein Plan für diese Domain aktiviert. Abonnieren Sie einen Plan und beginnen Sie, Ihre Website zu übersetzen",
      "trialUsage": "Sie verwenden derzeit {words_used} Wörter der {words_allowed} Wörter, die im Testplan enthalten sind.",
      "trialEnds": "Die Testversion für den ersten Monat ist bis zum {trial_ends} aktiviert.",
      "subscribeMessage": "Abonnieren Sie, bevor sie beendet ist, um Ihre Website übersetzt zu halten",
      "trialReachedLimit": "Sie haben die maximale Anzahl an übersetzten Wörtern für den Testzeitraum erreicht.\nAbonnieren Sie einen unserer Pläne, um Ihre Website weiterhin zu übersetzen.",
      "paidUsage": "Sie haben {words_used} verwendet / {words_allowed} übersetzte Wörter in Ihrem Plan verwendet.",
      "paidReachedLimit": "Sie haben die maximale Anzahl übersetzter Wörter für den aktuellen Plan erreicht.\nRüsten Sie Ihren Plan auf, um die Übersetzung Ihrer Website-Inhalte fortzusetzen.",
      "trialOfferedUsage": "Sie verwenden derzeit {words_used} wörter der {words_allowed} wörter, die im Testplan enthalten sind.(Einschließlich der angebotenen {free_words} wörter)",
      "paidOfferedUsage": "Sie haben in ihrem plan {words_used} / {words_allowed} übersetzte wörter verwendet.(Einschließlich der angebotenen {free_words} wörter)",
      "noPlanExtra": "Bitte beachten Sie, dass inaktive Domains und deren Daten regelmäßig automatisch gelöscht werden.",
      "planRecommended": "Basierend auf Ihrem aktuellen Übersetzungsvolumen ist der empfohlene Plan:",
      "planMaximumWords": "{{words}} wörter",
      "notHaveTranslatedWords": "Sie haben noch keine Übersetzung erstellt",
      "noPlanShopify": "Für diese Domain ist kein Plan aktiviert. Abonnieren Sie einen Plan in Ihrem Shopify-Dashboard und beginnen Sie mit der Übersetzung Ihrer Website",
      "subscribeMessageShopify": "Abonnieren Sie Ihr Shopify-Dashboard, bevor die Übersetzung abgeschlossen ist, damit Ihre Website weiterhin übersetzt bleibt"
    },
    "translationSetup": {
      "kicker": "SUBDOMAIN-EINRICHTUNG",
      "title": "Übersetzungseinrichtung prüfen",
      "description": "Prüfen Sie DNS, übersetzte Hosts, den Zugriff auf die Ursprungswebsite und Kontolimits.",
      "starting": "Wird geprüft...",
      "button": "Einrichtung prüfen",
      "viewLatest": "Letztes Ergebnis anzeigen",
      "viewCurrent": "Aktuelle Prüfung anzeigen",
      "runAgain": "Erneut prüfen",
      "viewDetails": "Details anzeigen",
      "hideDetails": "Details ausblenden",
      "error": "Einrichtung kann nicht geprüft werden",
      "allPassed": "Alle Prüfungen bestanden",
      "setupNeedsAttention": "Einrichtung erfordert Aufmerksamkeit",
      "setupNeedsAttentionDescription": "Eine oder mehrere Prüfungen sind fehlgeschlagen. Prüfen Sie die folgenden Punkte oder wenden Sie sich an den Linguise-Support.",
      "lastChecked": "Zuletzt geprüft: {{time}}",
      "domainOwnership": "Domaininhaberschaft",
      "domainOwnershipDescription": "Verifizierungsdatensatz gefunden",
      "domainOwnershipFailure": "Der DNS-Eintrag zur Bestätigung der Inhaberschaft konnte nicht verifiziert werden.",
      "translatedHosts": "Übersetzte Hosts",
      "translatedHostsDescription": "{{count}} Sprachhosts geprüft",
      "translatedHostsFailure": "Ein oder mehrere CNAME-Einträge für Sprachen sind falsch.",
      "subdomainPage": "Subdomain-Seite",
      "subdomainPageDescription": "{{count}} übersetzte Seiten akzeptieren HTTPS",
      "subdomainPageFailure": "Beim Öffnen einer oder mehrerer übersetzter Seiten ist die TLS-Verbindung fehlgeschlagen.",
      "originalSite": "Ursprungswebsite",
      "originalSiteDescription": "Prüfung von DNS, TLS und Antwort der Ursprungswebsite",
      "originalSiteFailure": "Die DNS-, TLS- oder Antwortprüfung der Ursprungswebsite ist fehlgeschlagen.",
      "documentationAdvice": {
        "dns": "DNS-Einrichtung prüfen",
        "tls": "HTTPS-Einrichtung prüfen",
        "origin": "Einrichtung der Ursprungswebsite prüfen",
        "diagnostic": "Fehlerbehebungsschritte ansehen"
      },
      "evidence": {
        "originDns": "Ursprungs-DNS",
        "originTls": "Ursprungs-TLS",
        "originHttp": "Antwort der Ursprungswebsite",
        "observedTargets": "Ermittelte Ziele",
        "recordCount": "Einträge gefunden",
        "addressCount": "Adressen gefunden",
        "statusCode": "HTTP-Status",
        "redirect": "Weiterleitung",
        "expiresAt": "Zertifikat läuft ab",
        "raw": "{{key}}",
        "noValue": "Kein Wert"
      },
      "checkerError": "Einige Prüfungen konnten nicht abgeschlossen werden.",
      "coreLocation": "Geprüft von {{location}}",
      "status": {
        "queued": "In Warteschlange",
        "running": "Wird ausgeführt",
        "completed": "Abgeschlossen",
        "failed": "Fehlgeschlagen",
        "passed": "Bestanden",
        "warning": "Warnung",
        "unknown": "Unbekannt",
        "skipped": "Übersprungen",
        "not_applicable": "Nicht zutreffend"
      }
    },
    "throttling": {
      "title": "Übersetzungslimit",
      "description": "Vorübergehende Nutzungslimits",
      "unavailable": "Vorübergehende Übersetzungslimits nicht verfügbar",
      "window": "{{used}} / {{max}} Wörter",
      "resetsIn": "Wird in {{time}} zurückgesetzt",
      "throttled": "Übersetzung vorübergehend pausiert",
      "throttledDescription": "Ein vorübergehendes Nutzungslimit wurde erreicht. Die Übersetzung wird fortgesetzt, sobald dieses Zeitfenster zurückgesetzt wird."
    }
  },
  "domain": {
    "wizard": {
      "stepLabel": "SCHRITT {{step}} VON {{total}}",
      "doneLabel": "FERTIG, SIE KÖNNEN MIT DEM ÜBERSETZEN BEGINNEN!",
      "finish": {
        "title": "",
        "description": "Dies ist der API-Schlüssel zur Verwendung auf Ihrer Website"
      },
      "instructions": "Installationsanweisung",
      "domainSetting": "Domäneneinstellung",
      "step": {
        "titleWordpress": "Wordpress",
        "titleJoomla": "Joomla",
        "titlePHP": "Skript PHP",
        "wizardWordpressStep1": "1. Installieren Sie die ",
        "wizardWordpressStep2": "\n 2. Kopieren Sie in den Plugin-Einstellungen Ihren API-Schlüssel und tragen Sie ihn ein\n",
        "wizardWordpressStep3": "3. Sie sind bereit zum Übersetzen\n\n",
        "wizardWordpressStep4": "Für eine detailliertere Anleitung schauen Sie bitte in unserer Dokumentation nach: ",
        "wizardJoomlaStep1": "1. Joomla-Paket-Link: ",
        "wizardJoomlaStep2": "\n2. Kopieren Sie in den Konfigurationseinstellungen der Erweiterung Ihren API-Schlüssel und tragen Sie ihn ein",
        "wizardJoomlaStep4": "\n 4. Sie sind bereit zum Übersetzen\n\n",
        "wizardJoomlaStep3": "3. Stellen Sie in der Modulkonfiguration die Sprachen ein, die Sie anzeigen möchten, und fügen Sie Ihr Modul an der gewünschten Stelle ein.",
        "wizardPhpStep1": "1. Laden Sie unser php-Skript und hier herunter ",
        "wizardPhpStep2": "\n2. Folgen Sie der Installationsanleitung auf unserer Dokumentationsseite hier ",
        "wizardPhpStep3": "\n3. Fügen Sie das Modul zu Ihren Seiten hinzu.",
        "wizardPhpStep4": "\n Kopieren Sie den folgenden Code und fügen Sie ihn in den Kopf Ihrer Html-Seite ein, dann wird das Switcher-Modul automatisch angezeigt\n",
        "dispatchStep1": "Wir haben die erforderlichen Daten erfolgreich an das Linguise-Plugin gesendet. Sie können das folgende Fenster jetzt schließen.",
        "dispatchStep2": "Falls das Token beim Schließen dieses Fensters fehlt, kopieren Sie bitte das folgende Token:",
        "dispatchStep3": "Sie können diesen Ausschnitt auch kopieren, um unseren Flaggenumschalter automatisch zu aktivieren",
        "wizardOtherStep1": "Befolgen Sie die nachstehenden Anweisungen, um Linguise auf Ihrer Domäne zu installieren.",
        "wizardOtherStep2": "Kopieren Sie den folgenden Code und fügen Sie ihn in den Kopf Ihrer HTML-Seite ein. Dadurch wird das Umschaltmodul automatisch angezeigt."
      },
      "trialAlreadyUsed": "Scheint so, als hätten Sie Ihre kostenlose Testversion bereits verbraucht, so dass Sie ein Übersetzungskontingent benötigen\nBitte abonnieren Sie einen Plan oder kontaktieren Sie uns, wenn Sie Ihre Testversion verlängern müssen.",
      "usefulLinks": "Nützliche Links für den Einstieg",
      "linkDocumentation": "Dokumentation",
      "linkExtensionDl": "Erweiterung herunterladen",
      "linkSubscribe": "Jetzt einen Plan abonnieren",
      "linkDashboard": "Zum Dashboard gehen",
      "exclusion": {
        "title": "Firmen- und Produktnamen",
        "description": ""
      },
      "finishButton": "Einrichtung beenden",
      "subdomains": "Subdomänen",
      "subdomain_setup": "Domäne einrichten",
      "subdomain_auto_setup": "Verbinden Sie Ihr DNS automatisch",
      "subdomain_manual_setup": "DNS-Einträge selbst hinzufügen",
      "subdomain_skip": "DNS-Einträge selbst hinzufügen",
      "auto_subdomains_info": "Ihr Site Builder-CMS erfordert eine DNS-Konfiguration, um Sprachen pro Subdomain festzulegen (z. B. de.domain.com). Mit Entri können Sie dies automatisch tun. Klicken Sie einfach auf die Schaltfläche „DNS automatisch verbinden“, um eine Verbindung zu Ihrem DNS-Manager herzustellen und diese mit Entri hinzuzufügen. ",
      "auto_subdomains_info_manual": "Sie können Ihre Domain auch manuell konfigurieren, indem Sie auf die Schaltfläche „DNS-Einträge selbst hinzufügen“ klicken.",
      "auto_subdomains_info_2": "Mit Entri können Sie dies automatisch tun. Klicken Sie einfach auf die Schaltfläche „DNS automatisch verbinden“, um eine Verbindung zu Ihrem DNS-Manager herzustellen und diese mit Entri hinzuzufügen. ",
      "breadcrumbs": {
        "step1": "Schritt 1: Domäne, CMS & Sprachen",
        "step2": "Schritt 2: Sprach-DNS",
        "step3": "Schritt {{step}}: Installationsanleitung"
      }
    },
    "form": {
      "urls": {
        "dash": "Minus -",
        "underscore": "Unterstrich _",
        "title": "URLs übersetzen",
        "description": "Möchten Sie auf allen Seiten übersetzen",
        "char_description": "Zeichen, das zum Ersetzen nicht autorisierter Zeichen in URLs verwendet wird",
        "advertisement_title": "⚠ Sie haben eine Vielzahl von Sprachen eingestellt.\n",
        "advertisement": "Wir raten in der Regel dazu, zunächst mit der Übersetzung von Websites in wenigen Sprachen zu beginnen. So haben Sie eine Vorstellung davon, wie viele Wörter Ihre Website hat. Es ist auch besser für die Suchmaschinenoptimierung, da Google-Bots alle Ihre Seiten schneller crawlen werden, wenn Sie zunächst weniger Seiten haben. Nach einer Woche können Sie ein paar weitere Sprachen hinzufügen und so weiter"
      },
      "url": {
        "title": "Url",
        "description": "Geben Sie Ihre Hauptdomain-URL ein, die mit http:// oder https:// beginnt.",
        "placeholder": "Domain-URL",
        "advertisement_http": {
          "title": "Sie verwenden nicht das https-Protokoll",
          "description": "Bitte überprüfen Sie, ob Ihre Domain tatsächlich nicht das heute empfohlene https-Protokoll verwendet."
        },
        "advertisement_www": {
          "title": "Ihre Subdomain ist nicht www",
          "description": "Die Standard-Subdomain ist meistens www (wie https://www.mydomain.com). Dies ist möglicherweise nicht der Fall, aber überprüfen Sie bitte, ob die Domain, die Sie hinzufügen möchten, die richtige ist."
        },
        "invalid_url": {
          "line1": "Wir konnten Ihre Domain nicht finden. Bitte stellen Sie sicher, dass Ihre Domain über das Internet öffentlich zugänglich ist und nicht an einen anderen Ort weitergeleitet wird. ",
          "line2": "Wenn Sie sicher sind, dass auf Ihre Domain zugegriffen werden kann, können Sie die Domainüberprüfung überspringen und erneut auf die Schaltfläche „Nächster Schritt“ klicken",
          "contact": "In jedem Fall können Sie uns unter kontaktieren",
          "force": "Überspringen Sie die Domänenüberprüfung"
        },
        "invalid_subdomain_url": "Diese URL ist nicht zulässig. Subdomains müssen folgendes Format haben: https://www.domain.tld oder https://domain.tld ohne Unterverzeichnis."
      },
      "account": {
        "title": "Konto",
        "description": "Wählen Sie ein Konto aus, um diese Domain zuzuweisen",
        "placeholder": "Konto auswählen...",
        "feedback": "Sie müssen ein Konto auswählen"
      },
      "platform": {
        "title": "Plattform",
        "description": "Bitte wählen Sie Ihre Website-Plattform anhand des CMS-Namens aus.",
        "learn": "Erfahren Sie, wie Sie es auswählen",
        "placeholder": "Plattform nach CMS-Namen suchen...",
        "info": {
          "title": "⚠ Diese Plattform wurde kürzlich hinzugefügt.\n",
          "desc": "Diese Website-Builder-Plattform wird von Linguise unterstützt, obwohl sie erst kürzlich hinzugefügt wurde. Wenn Sie auf ein Problem stoßen, kontaktieren Sie uns bitte über die direkte Support-E-Mail:"
        },
        "description_read_only": "Die Plattform, die Ihre Website verwendet",
        "feedback": "Sie müssen eine Plattform auswählen"
      },
      "language": {
        "title": "Sprache",
        "description": "Wählen Sie die Basissprache Ihrer Website",
        "placeholder": "Sprache wählen...",
        "feedback": "Sie müssen eine Sprache wählen",
        "description_read_only": "Basissprache Ihrer Website"
      },
      "token": {
        "title": "API-Schlüssel",
        "description": "Dies ist der API-Schlüssel, den Sie auf Ihre Website kopieren müssen",
        "copy": "In die Zwischenablage kopieren",
        "reset": "API Key zurücksetzen",
        "reset_confirm": "Bitte API Key-Reset bestätigen"
      },
      "languages": {
        "title": "Übersetzung Sprachen",
        "description": "Wählen Sie die Sprachen, in die Ihre Website übersetzbar sein soll",
        "placeholder": "Sprachen auswählen...",
        "feedback": "Sie müssen eine Sprache wählen"
      },
      "defaultRules": {
        "title": "Standardregeln",
        "description": "Wir haben eine Reihe von Regeln definiert, die verwendet werden müssen, um die Übersetzung zu verbessern und zu vermeiden, dass unerwünschte Inhalte wie das WordPress-Dashboard übersetzt werden.\nSie können diese Regeln später entfernen oder bearbeiten, wenn Sie dies wünschen."
      },
      "disallow_deletion": "Sie können keine Domäne mit aktivem Abonnement löschen",
      "delete_confirm": "Bitte bestätigen Sie die Löschung der Domain",
      "delete": "Domain löschen",
      "dynamic": {
        "title": "Übersetzen Sie dynamische Inhalte",
        "description": "Dynamische Inhalte, die durch JavaScript- und AJAX-Anfragen generiert werden, werden übersetzt (diese Option erhöht Ihre Übersetzungsnutzung)"
      },
      "partial_translations": {
        "title": "Teilübersetzung zulassen",
        "description": "Wenn Ihr Konto sein Übersetzungskontingent erreicht hat, die Seite jedoch noch übersetzt werden muss, kann Linguise die Seite weiterhin mit dem bereits übersetzten Inhalt anzeigen. Allerdings bleiben einige Teile der Seite unübersetzt, bis Sie Ihr Kontingent erhöhen. Während eine kleine Menge unübersetzter Inhalte in der Regel der Suchmaschinenoptimierung nicht schadet, könnte sich die Zulassung zu vieler unübersetzter Inhalte negativ auf das Benutzererlebnis auswirken. Um dieses Problem zu beheben, können Sie einen Schwellenwert für den Prozentsatz nicht übersetzter Inhalte festlegen, die auf einer Seite zulässig sind. Wenn der nicht übersetzte Inhalt diesen Schwellenwert überschreitet, werden Benutzer automatisch zur ursprünglichen Sprachversion der Seite weitergeleitet.",
        "never": "Niemals"
      },
      "translate_error_pages": {
        "title": "Fehlerseiten übersetzen",
        "description": "Linguise kann alle Fehlerseiten übersetzen. Wenn Ihre Fehlerseite jedoch dynamische Inhalte wie IP-Adressen oder Anforderungs-IDs enthält, sollten Sie die Übersetzung dieser Seiten vermeiden.",
        "not_found_page": {
          "title": "404-Seite übersetzen"
        },
        "error_page": {
          "title": "Übersetzen Sie andere Fehlerseiten"
        }
      },
      "plugin_mode": {
        "modal": {
          "title": "Vorhandene Domain gefunden",
          "description": "Für diesen Benutzer wurde eine vorhandene Domäne gefunden. Möchten Sie diese verwenden?"
        }
      },
      "search_tl": {
        "title": "Übersetzungen suchen",
        "description": "Aktivieren Sie Suchübersetzungen für Ihre Website-Plattform (experimentell, diese Option erhöht Ihre Übersetzungsnutzung)"
      },
      "shopify_promo": {
        "info": "Gute Neuigkeiten! Wir haben jetzt eine native Shopify-App, die Sie im Shopify App Store installieren können.",
        "hyperlink": "Klicken Sie hier und installieren Sie Linguise über die App.",
        "next_btn": "Gehen Sie zum Shopify-Shop, um die App zu installieren.",
        "info_legacy": "Gute Neuigkeiten! Wir haben jetzt eine native Shopify-App, die Sie im Shopify App Store installieren können.",
        "description_legacy": "Wählen Sie die Plattform \"Shopify\" anstelle von \"Shopify Legacy\""
      },
      "wix_promo": {
        "info": "Gute Neuigkeiten! Wir haben jetzt eine native Wix-App, die Sie im Wix App Market installieren können.",
        "hyperlink": "Klicken Sie hier und installieren Sie Linguise über die App.",
        "next_btn": "Gehen Sie zum Wix App Market, um die App zu installieren.",
        "info_legacy": "Gute Neuigkeiten! Wir haben jetzt eine native Wix-App, die Sie im Wix App Market installieren können.",
        "description_legacy": "Wählen Sie die Plattform \"Wix\" anstelle von \"Wix Legacy\""
      },
      "ai_disallow_deletion": "Diese Domain kann nicht gelöscht werden, solange noch ein KI-Kontingent verfügbar ist. Bitte kontaktieren Sie unser Support-Team, wenn Sie diese Domain löschen möchten.",
      "language_removal": {
        "card": {
          "title": "Übersetzungen entfernter Sprachen löschen",
          "description": "Diese Sprachen wurden von Ihrer Website entfernt, ihre gespeicherten Übersetzungen zählen jedoch weiterhin zu Ihrem Kontingent. Löschen Sie sie, um die Wörter zurückzuerhalten.",
          "button": "Übersetzungen löschen"
        },
        "hint": "Die dafür verwendeten Wörter werden Ihrem Kontingent gutgeschrieben. Sie können dies pro Website alle {{days}} Tage einmal tun.",
        "modal": {
          "title": "Übersetzungen löschen?",
          "intro": "Diese Übersetzungen werden dauerhaft gelöscht:",
          "warning": "Diese Aktion kann nicht rückgängig gemacht werden. Die verwendeten Wörter werden Ihrem Kontingent gutgeschrieben. Das kann einige Minuten dauern.",
          "limit": "Sie können dies pro Website alle {{days}} Tage einmal tun.",
          "confirm": "Übersetzungen löschen"
        },
        "scheduled": "Die Übersetzungen werden gelöscht und Ihr Kontingent wird in Kürze aktualisiert.",
        "cooldown": "Übersetzungen für diese Website wurden kürzlich gelöscht. Sie können sie am {{date}} wieder löschen.",
        "latest_completed": {
          "title": "Letzter abgeschlossener Löschvorgang",
          "description": "Sehen Sie sich die gelöschten Sprachen und die Ihrem Kontingent gutgeschriebenen Wörter an.",
          "languages": "Gelöschte Sprachen",
          "words_returned": "Ihrem Kontingent gutgeschriebene Wörter: {{words}}",
          "completed_at": "Abgeschlossen am {{date}}"
        },
        "status": {
          "recent_title": "Letzter Übersetzungslöschvorgang",
          "recent_description": "Verfolgen Sie den letzten Löschvorgang und sehen Sie, wann ein weiterer möglich ist.",
          "progress_title": "Löschfortschritt",
          "loading": "Löschfortschritt wird geprüft...",
          "unavailable": "Der Löschfortschritt konnte nicht geladen werden. Aktualisieren Sie die Seite und versuchen Sie es erneut.",
          "label": "Status",
          "pending": "Warteschlange",
          "processing": "In Bearbeitung",
          "completed": "Abgeschlossen",
          "failed": "Fehlgeschlagen",
          "unknown": "Status nicht verfügbar",
          "percent": "{{percent}} % abgeschlossen",
          "current_stage": "Aktueller Schritt: {{stage}}",
          "processed": "{{processed}} Datensätze verarbeitet",
          "processed_total": "{{processed}} von {{total}} Datensätzen verarbeitet",
          "requested_at": "Angefordert am {{date}}",
          "started_at": "Gestartet am {{date}}",
          "completed_at": "Abgeschlossen am {{date}}",
          "cooldown_period": "Sie können dies pro Website alle {{days}} Tage einmal tun.",
          "cooldown_blocked": "Ein weiterer Löschvorgang kann noch nicht gestartet werden.",
          "stage": {
            "queued": "Wartet auf den Start",
            "processing": "In Bearbeitung",
            "refund_summary": "Zurückgegebene Wörter werden berechnet",
            "search_translations": "Suchübersetzungen werden gelöscht",
            "url_translations": "URL-Übersetzungen werden gelöscht",
            "translations": "Übersetzungen werden gelöscht",
            "completed": "Abgeschlossen",
            "failed": "Fehlgeschlagen",
            "unknown": "In Bearbeitung"
          }
        },
        "forbidden": "Sie sind nicht berechtigt, Übersetzungen zu löschen."
      }
    },
    "main": {
      "edit": "Domain bearbeiten",
      "add": "Domain hinzufügen",
      "wizard": "Willkommen! Assistent zur Erstellung einer neuen Domain",
      "common": "Domain"
    },
    "subdomains": {
      "config_ok": "Das DNS der Subdomains wurde ordnungsgemäß konfiguriert.",
      "config_invalid": "Subdomains-DNS erfordert einige zusätzliche Konfigurationen, damit es funktioniert.",
      "config_check": "Die DNS-Konfiguration der Subdomains wird überprüft, bitte warten...",
      "entri_timeout": "Entri hat gemeldet, dass der DNS-Verbreitungsprozess Ihrer Subdomains abgelaufen ist. Sie müssten es erneut versuchen oder können es manuell durchführen.",
      "entri_process": "Ihr DNS wurde mit Entri hinzugefügt und die Verbreitung dauert normalerweise 10 bis 30 Minuten (alle Ihre Sprach-Subdomains wie de.domain.com anwenden). Wenn die DNS-Validierung nach 24 Stunden noch nicht abgeschlossen ist, können Sie unser Support-Team erreichen: support@linguise.com ",
      "entri_ok": "Die DNS-Verbreitung ist im Gange! Warten auf die Verbreitung... ",
      "infos": "Um die Übersetzung zu aktivieren, müssen Sie diese DNS-Einträge zu Ihren DNS-Domänendatensätzen hinzufügen. Klicken Sie anschließend auf die Schaltfläche „Prüfen“. Die DNS-Einträge können einige Zeit zur Aktualisierung benötigen. Versuchen Sie es daher gegebenenfalls nach einigen Minuten oder Stunden erneut.",
      "check": "DNS-Konfiguration prüfen"
    },
    "notice": {
      "broken_card": "Wir konnten Ihren Plan für {{url}} mit der aktuellen Zahlungsmethode nicht verlängern. Bitte aktualisieren Sie Ihre Zahlungskarte",
      "quota_reached": "Ihr Übersetzungskontingent für {{url}} wurde erreicht. Bitte führen Sie ein Upgrade durch, um mit der Übersetzung Ihrer Website fortzufahren",
      "important": "Wichtig",
      "quota_reached_button": "Aktualisieren Sie jetzt Ihren Plan",
      "broken_card_button": "Aktualisieren Sie Ihre Zahlungskarte",
      "ai_no_subscription": "Die KI-Übersetzung für {{url}} erfordert ein aktives Abonnement oder eine aktive Testversion. Ohne diese wird die Übersetzung beendet. Bitte aktualisieren Sie, um fortzufahren.",
      "ai_no_subscription_button": "Aktualisieren Sie jetzt Ihren Plan",
      "quota_warning": "Ihr Übersetzungskontingent für {{url}} hat {{throttling_used_percent}}% erreicht. Es wird in {{ttl}} zurückgesetzt.",
      "locked": "Die Domain {{url}} ist derzeit für die Migration gesperrt. Sie können weiterhin auf Ihre Website zugreifen, aber keine Übersetzungen bearbeiten oder neue hinzufügen!"
    },
    "subscription": {
      "next_payment_amount": "Anstehende Anklagen",
      "next_payment_date": "Nächster Zahlungstermin",
      "invoice": {
        "header": "Rechnungshistorie",
        "date": "Datum",
        "amount_due": "Menge",
        "status": "Status",
        "actions": "Aktionen",
        "description": "Sobald Transaktionen verfügbar sind, können Sie diese hier einsehen.",
        "status_text": {
          "draft": "Entwurf",
          "open": "Ausstehend",
          "paid": "Bezahlt",
          "uncollectible": "Uneinbringlich",
          "void": "Leere",
          "failed": "Fehlgeschlagen",
          "retrying": "Wiederholung"
        },
        "view": "Sicht",
        "empty": "Für dieses Abonnement sind keine aktuellen Rechnungen gefunden",
        "retry_payment": "Wiederholen"
      },
      "next_cancellation": "Stornierungsdatum",
      "cancel": "Abo kündigen",
      "change_plan": "Plan ändern",
      "change": "Ändern",
      "suspend": "Zahlung aussetzen",
      "resume": "Abonnement fortsetzen",
      "back": "Zurück",
      "save": "Speichern",
      "confirm_resume": "Sind Sie sicher, dass Sie dieses Abonnement fortsetzen möchten?",
      "confirm_cancel": "Sind Sie sicher, dass Sie dieses Abonnement kündigen möchten?",
      "confirm_header": "Bist du sicher?",
      "missing_status": "Dieses Abonnement fehlt",
      "not_found": "Für diese Domain wurde kein Abonnement gefunden",
      "no_payment_method": "Unbekannt",
      "remove_billing": "Entfernen",
      "confirm_manual_retry": "Möchten Sie diese Zahlung wirklich wiederholen?",
      "shopify_maneged": "Dieses Abonnement wird von Shopify verwaltet. Bitte verwalten Sie es über Ihr Shopify-Administrationsbereich.",
      "unknown_plan": "Unbekannter Plan"
    }
  },
  "domain_listing": {
    "select": "Domain auswählen",
    "add": "Website hinzufügen"
  },
  "editable": {
    "number": "Nummer {{id}}"
  },
  "footer": {
    "about": "Über",
    "support": "Unterstützung"
  },
  "frontendEditor": {
    "main": "Live-Editor",
    "description": "Mit dem Live-Editor können Sie die Übersetzungen direkt in Ihrer Website bearbeiten.",
    "button": "Live-Editor öffnen",
    "language_selection": "Auswahl der Übersetzungssprache",
    "video_label": "Erfahren Sie, wie Sie den Live-Editor verwenden"
  },
  "general": {
    "403": {
      "tab_title": "Ooops - 403 Fehler",
      "title": "Zugriff verweigert",
      "message": "Sie haben anscheinend keinen Zugriff auf die angeforderte Seite.",
      "home": "Zurück zur Startseite"
    },
    "404": {
      "tab_title": "Ooops - 404 Fehler",
      "title": "Seite nicht gefunden",
      "message": "Es sieht so aus, als wären Sie vielleicht falsch abgebogen. Keine Sorge... das passiert auch den Besten von uns. Hier ist ein kleiner Tipp, der Ihnen helfen könnte, wieder in die Spur zu kommen.",
      "home": "Zurück zur Startseite"
    },
    "500": {
      "tab_title": "500 Fehler",
      "title": "Interner Serverfehler",
      "message": "Versuchen Sie doch mal, Ihre Seite zu aktualisieren. Oder kontaktieren Sie uns",
      "home": "Zurück zur Startseite"
    },
    "fields": {
      "alert": "Einige Felder sind nicht gültig, bitte korrigieren Sie die ungültigen Felder.",
      "invalid": "Dieses Feld ist ungültig",
      "phone_re": "Die Telefonnummer ist ungültig",
      "phone_invalid": "Die Telefonnummer ist ungültig",
      "email": "Das E-Mail-Feld ist ungültig."
    },
    "saving": "Speichern ...",
    "save": "Speichern",
    "save_and_quit": "Speichern und beenden",
    "invite": "Einladen",
    "cancel": "Abbrechen",
    "yes": "Ja",
    "no": "Nein",
    "nextStep": "Nächster Schritt",
    "loading": "Bitte warten Sie, bis die Anwendung geladen ist",
    "goback": "Zurück",
    "manage": "Verwalten",
    "delete": "Löschen",
    "deleting": "Löschen...",
    "table": {
      "no_data": "Hier liegen noch keine Daten vor..."
    },
    "confirm": "Bestätigen",
    "unknown": "Unbekannt",
    "hide": "Verstecken",
    "show": "Zeigen",
    "on": "An",
    "off": "Aus",
    "default": "Standard"
  },
  "home": {
    "header": "Zuhause",
    "manage": "Abonnement verwalten",
    "activate_now": "Jetzt aktivieren",
    "activate_plan_now": "Abonniere jetzt",
    "upgrade_plan_now": "Jetzt Plan upgraden",
    "trial_message_part_1": "Sie nutzen derzeit den Testplan ",
    "trial_message_part_2": "und können jederzeit eine Mitgliedschaft aktivieren.",
    "add": "Domain hinzufügen",
    "table": {
      "title": "Domänen",
      "description": "Liste Ihrer Domains. Klicken Sie auf die Domain, um Übersetzungen zu verwalten"
    },
    "domains": {
      "empty": "Sie haben keine Domains in diesem Konto"
    },
    "accountsList": {
      "title": "Konten",
      "add": "Neues Konto hinzufügen",
      "name": "Kontobezeichnung"
    },
    "update_credit_card": "Kreditkartendaten aktualisieren",
    "canceled": "Abonnement gekündigt",
    "cancelling_subs": "Stornierung um {{0}}",
    "resume_subscription": "Abonnement fortsetzen",
    "shopify_managed": "Verwaltet von Shopify",
    "trial_ends_at": "Endet um {{0}}",
    "free_trial": "Kostenlose Testversion",
    "no_subs": "Kein aktives Abonnement"
  },
  "invoices": {
    "title": "Rechnungen",
    "list": {
      "title": "Liste der Rechnungen"
    },
    "table": {
      "customer": "Kunde",
      "domain": "Domain",
      "amountPaid": "Gezahlter Betrag",
      "status": "Status",
      "date": "Datum",
      "invoice": "Rechnung",
      "pay": "Rechnung bezahlen",
      "actions": "Aktionen",
      "deleted_domain": "Domain gelöscht",
      "plan_name": "Planen",
      "action": "Aktion"
    },
    "listPending": {
      "title": "Liste der ausstehenden Rechnungen"
    }
  },
  "language_settings": {
    "display": "Anzeige der Sprachliste",
    "position": "Position",
    "display_help_text": "Flaggen- und/oder Sprachnamen anzeigen. Die Standardposition des Sprachumschalters kann an einer beliebigen Stelle im Inhalt oder an einer festen Position liegen, die fest bleibt oder sich beim Scrollen verschiebt",
    "side_by_side": "Seite an Seite",
    "dropdown": "Dropdown-Liste",
    "popup": "Aufpoppen",
    "flag": "Flagge",
    "lang_name": "Sprache Name",
    "lang_short_name": "Kurznamen",
    "positions": {
      "in_place": "An Ort und Stelle",
      "top_left": "Oben links",
      "top_left_no_scroll": "Oben links (ohne Scrollen)",
      "top_right": "Oben rechts",
      "top_right_no_scroll": "Oben rechts (ohne Scrollen)",
      "bottom_left": "Unten links",
      "bottom_left_no_scroll": "Unten links (ohne Scrollen)",
      "bottom_right": "Unten rechts",
      "bottom_right_no_scroll": "Unten rechts (ohne Scrollen)"
    },
    "lang_names_display": {
      "title": "Sprachnamen werden angezeigt",
      "help_text": "Zeigen Sie im Sprachumschalter die Sprachnamen in Englisch oder in der Originalsprache an, also Französisch oder Français",
      "english": "Englisch",
      "native_languages": "Muttersprache"
    },
    "flag_shape": {
      "title": "Flaggenstil",
      "help_text": "Verwenden Sie runde SVG- oder rechteckige SVG-Flaggensymbole",
      "round": "Runden",
      "rectangular": "Rechteckig"
    },
    "english_flag_type": {
      "title": "Englischer Flaggentyp",
      "help_text": "Verwenden Sie für Englisch die Flagge Großbritanniens oder der USA",
      "usa": "Usa Flagge",
      "great_britain": "Flagge Großbritanniens"
    },
    "german_flag_type": {
      "title": "Deutscher Flaggentyp",
      "help_text": "Verwenden Sie für Deutsch die österreichische oder deutsche Flagge",
      "german": "Deutsche Flagge",
      "austria": "Österreich-Flagge"
    },
    "spain_flag_type": {
      "title": "Spanischer Flaggentyp",
      "help_text": "Verwenden Sie für Spanisch die mexikanische oder spanische Flagge",
      "spanish": "Spanische Flagge",
      "mexico": "Mexiko-Flagge",
      "peruvian": "Peruanische Flagge"
    },
    "portugal_flag_type": {
      "title": "Portugiesischer Flaggentyp",
      "help_text": "Verwenden Sie für Portugiesisch die portugiesische oder",
      "portugal": "Portugiesische Flagge",
      "brazil": "Brasilianische Flagge"
    },
    "taiwanese_flag_type": {
      "title": "Typ der taiwanesischen Flagge",
      "help_text": "Verwenden Sie für Taiwanesisch die taiwanesische oder chinesische Flagge",
      "taiwanese": "Taiwanesische Flagge",
      "chinese": "Chinesische Flagge"
    },
    "flag_border_radius": {
      "title": "Flaggenrandradius (px)",
      "help_text": "Wenn Sie die rechteckige Flaggenform verwenden, können Sie einen benutzerdefinierten Randradius in Pixeln anwenden"
    },
    "flag_width": {
      "title": "Flaggengröße (px)",
      "help_text": "Wählen Sie die Flaggengröße in Pixel aus. Das Bildgewicht ändert sich dadurch nicht, da es sich um ein .svg-Format handelt"
    },
    "lang_color": {
      "color_title": "Farbe des Sprachnamens",
      "color_help_text": "Wählen Sie eine Standardtextfarbe für Ihre Sprachnamen",
      "hover_color_title": "Schwebefarbe für den Namen der Sprache",
      "hover_color_help_text": "Wählen Sie eine Textfarbe für den Mauszeiger für Ihre Sprachnamen aus",
      "color_popup_title": "Farbe der Popup-Sprache",
      "color_popup_help_text": "Farbe des Sprachtitels im Popup oder in den Dropdown-Bereichen",
      "hover_color_popup_title": "Hover-Farbe der Popup-Sprache",
      "hover_color_popup_help_text": "Wählen Sie im Popup oder in den Dropdown-Bereichen eine Textfarbe für den Sprachtitel aus, in der Sie mit der Maus darüber fahren"
    },
    "flag_box_shadow": {
      "shadow_title": "Schatten der Flaggenbox",
      "shadow_help_text": "Farbe und Schattengröße für Ihre Sprachflaggen",
      "hover_shadow_title": "Schatten des Flaggenkastens beim Schweben",
      "hover_shadow_help_text": "Farbe und Schattengröße für Ihre Sprachflaggen beim Bewegen der Maus",
      "shadow_h_offset": "Schatten-H-Versatz (px)",
      "shadow_v_offset": "Schatten-V-Versatz (px)",
      "shadow_blur": "Schattenunschärfe (px)",
      "shadow_spread": "Schattenausbreitung (px)",
      "shadow_color": "Schattenfarbe"
    },
    "order": "Sprachordnung",
    "language_order_help": "Die Reihenfolge der Sprache, die im Sprachumschalter angezeigt wird. Sie können die Sprache per Drag-and-Drop verschieben, um sie neu anzuordnen. ",
    "order_reset": "Reihenfolge zurücksetzen",
    "language_order_dragdrop": "Sie können die Sprache ziehen und fallen lassen, um sie neu zu ordnen.",
    "popup_lang_name": "Name der Popup-Sprache",
    "preview": "Sprachvorschau"
  },
  "link": {
    "form": {
      "original": {
        "title": "Originalquelle",
        "description": "Fügen Sie Ihre ursprüngliche Link-URL hinzu und ersetzen Sie sie unten durch die Sprache, um sie zu übersetzen",
        "srcset_description": "Sie bearbeiten eine Bild-URL. Bitte lesen Sie unbedingt die Dokumentation, insbesondere wenn Sie srcset verwenden oder nicht wissen, was es ist",
        "link": "Verknüpfung",
        "match_link": "Match-Modus",
        "match_exact": "Genau",
        "match_wildcard": "Platzhalter",
        "match_regex": "Regulärer Ausdruck"
      },
      "alternative_languages": {
        "title": "Verknüpfungen zum Ersetzen",
        "description": "Ersetzen Sie Medienlinks und externe Links auf allen Ihren Seiten, nach Sprache…",
        "link": "Link zum Ersetzen"
      },
      "error": {
        "atLeastOne": "Bitte fügen Sie mindestens eine Übersetzung hinzu.",
        "url": "Die URL ist ungültig",
        "extension": "Der Link sollte eine Erweiterung haben, darf aber nicht .html oder .php sein. Und der Link sollte keinen Sprachpfad enthalten, z. B. „/fr“",
        "regex": "Der reguläre Ausdruck ist ungültig",
        "wildcard": "Der Wildcard-Link hat ein ungültiges Protokoll"
      }
    },
    "main": {
      "parent": "Verknüpfungen",
      "edit": "Link bearbeiten"
    }
  },
  "links": {
    "title": "Verwaltung von Medien und externen Links",
    "description": "Auflisten und Bearbeiten Ihrer Website Medienlinks oder externe Links.",
    "add": "Link hinzufügen",
    "delete": "Verknüpfung löschen",
    "table": {
      "original": "Original",
      "language": "Sprache",
      "translation": "Übersetzung",
      "action": "Aktion",
      "delete_confirm": "Bitte bestätigen Sie das Löschen des Links"
    }
  },
  "members": {
    "header": "Mitglieder",
    "invite": "Lade ein neues Mitglied ein",
    "modal": {
      "inviteHeader": "Lade ein neues Mitglied ein",
      "editHeader": "Mitglied bearbeiten",
      "detachHeader": "Mitglied abnehmen",
      "detachBody": "Möchten Sie das Mitglied wirklich von diesem Konto trennen?",
      "selfDetachBody": "Sind Sie sicher, dass Sie sich von dieser Kontoverwaltung trennen möchten? Danach haben Sie keinen Zugriff mehr auf die mit diesem Konto verbundenen Daten."
    },
    "table": {
      "title": "Mitgliederliste",
      "description": "Mitgliederrollen und Domänenzugriff",
      "name": "Name",
      "email": "Email",
      "websites": "Websites",
      "languages": "Sprachen",
      "role": "Rolle",
      "status": "Status",
      "resendInvite": "erneut senden",
      "inviteSent": "einladung wurde gesendet",
      "actions": "Aktionen",
      "edit": "Bearbeiten",
      "detach": "Ablösen",
      "empty": "Sie haben noch keine Mitglieder",
      "all_website": "Alle Websites und Sprachen",
      "roles": {
        "admin": "Administrator",
        "manager": "Manager",
        "translator": "Übersetzer"
      },
      "statuses": {
        "pending": "Ausstehend",
        "accepted": "Akzeptiert",
        "declined": "Abgelehnt"
      }
    },
    "errors": {
      "role": "Sie müssen eine Rolle auswählen",
      "domains": "Sie müssen mindestens 1 Website für die ausgewählte Rolle auswählen",
      "languages": "Sie müssen mindestens 1 Sprache für ausgewählte Websites auswählen"
    },
    "inviteSent": "Ihre Einladung wurde erfolgreich gesendet"
  },
  "pagination": {
    "showing": "Zeigt {{limit}} von {{total}} Ergebnissen",
    "showing_only_count": "Zeigt {{limit}} Ergebnissen"
  },
  "payments_method": {
    "header": "Zahlungsmethoden",
    "table": {
      "title": "Liste der Zahlungsmethoden",
      "description": "Ihrem Konto zugeordnete Zahlungsmethoden",
      "default": "Standard",
      "action_edit_remove": "Bearbeiten oder entfernen",
      "action_remove": "Entfernen",
      "action_default": "Als Standard festlegen",
      "action_fallback": "Als Fallback festlegen",
      "expires": "Läuft ab",
      "add_new_card": "Zahlungsmethode hinzufügen",
      "action_fallback_remove": "Aus Fallback entfernen",
      "fallback": "Zurückgreifen",
      "action_edit": "Bearbeiten",
      "action_delete": "Löschen",
      "action_default_remove": "Als Standard entfernen",
      "domain_count@@one": "Verwendet von {{count}} Domänen",
      "domain_count@@other": "Wird von {{count}} Domains verwendet"
    },
    "paypal_bind": {
      "button": "PayPal-Konto verbinden",
      "button_load": "Verbinden...",
      "disconnected": "Nicht verbunden",
      "error": "Es ist ein Fehler aufgetreten",
      "success_header": "Erfolg",
      "success_no_promo": "Ihr PayPal-Konto ist nun verbunden",
      "success": "Ihr PayPal-Konto ist nun verbunden. Von Ihrer nächsten Rechnung werden 5 $ abgezogen!"
    },
    "card_add": {
      "header": "Neue Karte hinzufügen",
      "success": "Neue Karte mit Linguise verbunden!",
      "terms": "Durch die Angabe Ihrer Karteninformationen gestatten Sie Linguise, Ihre Karte gemäß unseren Nutzungsbedingungen für zukünftige Zahlungen zu belasten."
    },
    "card_detail": {
      "header": "Karteninformationen",
      "delete": {
        "error": "Sie können diese Zahlungsmethode nicht löschen, da sie über aktive Abonnements verfügt!"
      }
    },
    "subscriptions": {
      "table": {
        "description": "Abonnements mit dieser Zahlungsmethode",
        "header_domain": "Domain",
        "header_plan": "Planen",
        "header_status": "Status",
        "header_actions": "Aktionen",
        "cancelling": "Stornierung um: {{0}}",
        "next_payment": "Nächste Zahlung bei: {{0}}",
        "action_renew": "Erneuern",
        "no_subs_header": "Keine Abonnements zum Anzeigen vorhanden",
        "no_subs_desc": "Sobald ein Abonnement für diese Karte abgeschlossen ist, werden alle Informationen hier angezeigt",
        "action_manage": "Verwalten"
      },
      "status": {
        "active": "Aktiv",
        "canceled": "Abgesagt",
        "incomplete": "Unbezahlt",
        "incomplete_expired": "Unbezahlt (abgelaufen)",
        "past_due": "Überfällig",
        "trialing": "Versuch",
        "unpaid": "Unbezahlt",
        "missing": "Fehler"
      }
    },
    "delete_confirm_body": "Möchten Sie diese Zahlungsmethode wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden!",
    "delete_confirm_header": "Zahlungsart löschen?",
    "card_edit": {
      "header": "Karte bearbeiten",
      "billing_header": "Abrechnungsdaten",
      "address_error": "Adresse ist erforderlich!",
      "card_number": "Kartennummer",
      "card_expiry": "Verfallsdatum",
      "expiry_error_month": "Ungültiger Monat angegeben",
      "expiry_error_year": "Ungültiges Jahr angegeben",
      "expiry_error_expired": "Das Ablaufjahr Ihrer Karte liegt in der Vergangenheit.",
      "card_header": "Karteninformationen",
      "expiry_error_empty": "Dieses Feld ist erforderlich!"
    }
  },
  "plans": {
    "per": "pro",
    "wordsTranslated": "übersetzte Wörter",
    "current": "Aktuell",
    "archived": "Archiviert",
    "day": "Tag",
    "week": "Woche",
    "month": "Monat",
    "year": "Jahr",
    "activate": "Aktivieren",
    "cancel": "Abbrechen",
    "change": "Ändern",
    "upgrade": "Tarif hochstufen",
    "downgrade": "Tarif herabstufen",
    "notEnoughWords": "Nicht genug Worte",
    "yearIntervalOnly": "Kann nicht vom Jahrestarif migrieren",
    "wordsUnlimited": "Unbegrenzte Worte",
    "tabs": {
      "day": "Tägliche Preise",
      "week": "Wöchentliche Preise",
      "month": "Monatliche Preise",
      "year": "Jährliche Preise",
      "sub_texts": {
        "day": "Ein Festpreis, jeden Tag",
        "week": "Ein Festpreis, jede Woche",
        "month": "Jeden Monat ein Festpreis",
        "year": "Ein Monat kostenlos, eine Rechnung pro Jahr"
      }
    },
    "details": {
      "new_languages": "Fügen Sie jederzeit neue Sprachen hinzu",
      "one_month_trial": "Einmonatige kostenlose Testversion für jede neue Website",
      "multi_content_indexed": "100 % der mehrsprachigen Inhalte indexiert",
      "translate_new_content": "Übersetzen Sie neue Inhalte sofort",
      "free_installation": "Kostenlose Installation und Einrichtung",
      "compared_monthly_plan": "Ein Monat kostenlos im Vergleich zu monatlichen Plänen",
      "risk_free_recurring": "Risikofreier wiederkehrender Zahlungsausfall",
      "unlimited_languages": "Unbegrenzte Sprachen und Seitenaufrufe",
      "high_server_resources": "Hohe Serverressourcen",
      "billed": {
        "day": "Tägliche Abrechnung",
        "week": "Wöchentliche Abrechnung",
        "month": "Wird monatlich abgerechnet",
        "year": "Jährliche Abrechnung"
      },
      "request_max_size": "{{0}} maximale Anfragegröße"
    },
    "frequent_question": {
      "title": "Häufige Fragen",
      "questions": {
        "trial": {
          "question": "Kann ich die Testversion auf einer neuen Website-Domain verwenden?",
          "answer": "Ja, wir bieten eine 30-tägige kostenlose Testversion für jede neue Website-Domain an, die Sie Ihrem Konto hinzufügen. Auf diese Weise können Sie den Übersetzungsdienst auf Ihrer neuen Website vollständig testen."
        },
        "seo": {
          "question": "Wie lange dauert es, bis sich meine SEO verbessert?",
          "answer": "Es dauert einige Zeit, bis Inhalte und mehrsprachige Inhalte vollständig indiziert sind und ein gutes Ranking erhalten. Abhängig vom Traffic und der Größe Ihrer Website beträgt die Dauer zwischen 3 und 6 Wochen."
        },
        "quota": {
          "question": "Sind die menschlichen Übersetzungen im Kontingent enthalten?",
          "answer": "Nein, die Wortzahlbeschränkung gilt nur für automatische maschinelle Übersetzungen. Ein Übersetzer kann automatische Übersetzungen ohne Einschränkung manuell bearbeiten."
        }
      }
    },
    "best_offer": "Bestes Angebot",
    "resume": "Wieder aufnehmen",
    "subsCanceled": "Es ist eine weitere Abonnementkündigung im Gange",
    "period": {
      "days@@one": "Tag",
      "days@@other": "{{count}} Tage",
      "hours@@one": "Stunde",
      "hours@@other": "{{count}} Stunden",
      "minutes@@one": "Minute",
      "minutes@@other": "{{count}} Minuten",
      "seconds@@one": "zweite",
      "seconds@@other": "{{count}} Sekunden"
    },
    "words": {
      "billion": "{{value}} Mrd.",
      "million": "{{value}} Mio.",
      "thousand": "{{value}} Tsd."
    },
    "throttling_info": "{{words}} Wörter pro {{period}}"
  },
  "profile": {
    "welcome": "Willkommen!",
    "account": "Mein Konto",
    "subscriptions": "Abonnements",
    "logout": "Abmelden"
  },
  "register": {
    "errors": {
      "password": "Mindestens 8 Zeichen, beliebiges Zeichen"
    }
  },
  "route": {
    "dashboard": "Dashboard",
    "rules": "Regeln",
    "translations": "Übersetzungen",
    "search_translations": "Übersetzungen suchen",
    "urls_translations": "Url-Übersetzungen",
    "links": "Medien und externe Links",
    "online_editor": "Live-Editor",
    "settings": "Einstellungen",
    "domain": {
      "finish": "Einstellungen",
      "preconfig": "Einstellungen"
    },
    "home": "Zuhause",
    "domain_list": "Domainliste",
    "members": "Mitglieder",
    "invoices": "Rechnungen",
    "billing": "Rechnungsdetails",
    "language_display": "Sprachflaggen werden angezeigt",
    "payment_methods": "Zahlungsmethoden",
    "ai_translation": "KI-Übersetzung",
    "ai_translation_settings": "Einstellungen",
    "ai_translation_pricing": "Preise"
  },
  "rule": {
    "form": {
      "text_ignore": {
        "placeholder": "Zu ignorierender Text",
        "add": "Neu hinzufügen",
        "title": "Zu ignorierender Text",
        "description": "Einen oder mehrere Texte zum Ignorieren hinzufügen",
        "ignore_case": "Häuser ignorieren"
      },
      "html_content": {
        "title": "Auf html-Inhalte anwenden",
        "description": "Anwenden von Regeln auf den gesamten Inhalt oder durch Auswahl eines bestimmten CSS-Selektors",
        "all_page": "Gesamte Seite",
        "css_selector": "CSS-Selektor",
        "label": "CSS-Selektor",
        "placeholder": "Selektor zum Anwenden auf",
        "add": "Neu hinzufügen"
      },
      "apply_to_urls": {
        "title": "Auf URLs anwenden",
        "description": "Wählen Sie bestimmte URLs aus, auf die die Regel angewendet werden soll",
        "all_urls": "Alle URLs",
        "selected_urls": "Ausgewählte URLs",
        "label": "Url zum Anwenden auf",
        "placeholder": "Url zum Anwenden auf",
        "original_url": "Originale URLs",
        "translated_url": "Übersetzte URL",
        "wildcard": "Platzhalter",
        "regex": "Regulärer Ausdruck",
        "add": "Neu hinzufügen",
        "expression": "Ausdruckstyp"
      },
      "apply_urls": {
        "title_exclude": "Ausschließen in URLs",
        "title_replace": "Ersetzen in URLs",
        "title_description": "Diese Regel auch auf die Übersetzung von URLs anwenden"
      },
      "apply_languages": {
        "title": "Auf Sprachen anwenden",
        "description": "Wählen Sie eine bestimmte Sprache aus, für die die Regel gelten soll",
        "all_languages": "Alle Sprachen",
        "selected_languages": "Ausgewählte Sprachen",
        "placeholder": "Ausgewählte Sprachen...",
        "feedback": "Sie müssen eine Sprache wählen"
      },
      "name": {
        "title": "Titel",
        "description": "Geben Sie Ihrer Regel der Einfachheit halber einen Titel",
        "placeholder": "Regelname"
      },
      "type": {
        "title": "Typ",
        "description": "Wählen Sie den Typ der Regel, die Sie hinzufügen möchten",
        "text_ignore": "Text ignorieren",
        "text_replace": "Text ersetzen",
        "content_exclusion": "Inhaltlicher Ausschluss",
        "url_exclusion": "Ausschluss der Url-Übersetzung",
        "ignore_inline": "Inline ignorieren",
        "full_description": {
          "text_ignore": "Fügen Sie Regeln hinzu, um zu verhindern, dass bestimmter Text übersetzt wird. Dabei kann es sich um Ihren Produktnamen, Markennamen oder andere technische Elemente handeln, die nicht übersetzt werden sollen.",
          "text_replace": "Mit der Funktion \"Text ersetzen\" können Sie einen Teil des Textes durch die gewünschte Übersetzung ersetzen; dies kann notwendig sein, wenn die Übersetzung den Kontext ignoriert.",
          "content_exclusion": "Wenn Sie eine Seite komplett von der Übersetzung ausschließen möchten (überhaupt keine mehrsprachige URL für diese Seite und kein übersetzter Inhalt), verwenden Sie bitte den Typ \"Url-Übersetzungsausschluss\".",
          "url_exclusion": "Mit dem Ausschluss der Seitenübersetzung können Sie die Seiten festlegen, die Sie nicht übersetzen möchten.",
          "ignore_inline": "Vermeiden Sie die Übersetzung einiger Inhalte als Inline-Inhalte, übersetzen Sie stattdessen jedes Tag separat."
        }
      },
      "text_replace": {
        "title": "Zu ersetzender Text",
        "description": "Ersetzen Sie einen Text durch Ihre spezifische Übersetzung. Ersetzen Sie einen beliebigen Text auf Ihren Seiten nach Sprache.",
        "text_to_replace": "Zu ersetzender Text",
        "ignore_case": "Fall ignorieren",
        "text_type": "Ersetzen in der Übersetzung",
        "text_type_original": "Original",
        "text_type_translation": "Übersetzung",
        "keep_case": "Fall versuchen zu halten",
        "add": "Neu hinzufügen"
      },
      "content_exclusion": {
        "title": "Inhaltlicher Ausschluss",
        "description": "Wählen Sie einen oder mehrere CSS-Selektoren, die nicht übersetzt werden sollen",
        "label": "CSS-Selektor",
        "placeholder": "Selektor zum Anwenden auf",
        "add": "Neu hinzufügen"
      },
      "multilingual_url": {
        "title": "Mehrsprachige URL verwenden",
        "description": "Bei der Einstellung Ja wird die URL NICHT übersetzt, aber die Seite bleibt mehrsprachig mit einem übersetzten Inhalt",
        "live_example_title": "Live-Beispiel",
        "live_example_description": "Quelle URL: https://yourwebsite.com/page-not-translated",
        "live_example_multilingual": "Generierte URL: https://yourwebsite.com/fr/page-not-translated",
        "live_example_no_multilingual": "Generierte URL: https://yourwebsite.com/page-not-translated"
      },
      "rule_application": {
        "description": "Wenden Sie die Regel auf statischen Inhalt oder dynamischen Inhalt oder beides an",
        "title": "Bewerben Sie sich für Inhalte",
        "all": "Alle Inhalte",
        "static": "Statischer Inhalt",
        "dynamic": "Dynamischer Inhalt"
      },
      "force_apply_urls": {
        "title_description": "Force Wenden Sie diese Regel auf alle Übersetzungen von URLs an, einschließlich vorhandener Übersetzungen!",
        "title_replace": "Kraft Ersatz in URLs",
        "title_exclude": "Kraft, die in URLs ausgeschlossen werden",
        "warning": "Warnung",
        "warning_part1": "Wenn Sie dies auf \"Ja\" einstellen, kann es zu Ihren Website -URL -Übersetzungen führen.",
        "warning_part2": "Dies kann vorübergehend oder dauerhaft eine 404S -Seite erzeugen. Bitte fahren Sie nur fort, wenn Sie die Konsequenzen verstehen.",
        "warning_replacement_original": "Zusätzliche Warnung: Sie versuchen, den ursprünglichen Inhalt zu ersetzen, der die URL beeinflusst, die Übersetzung kann fehlschlagen, da Linguise die ursprünglichen URLs nicht richtig finden können"
      }
    },
    "main": {
      "parent": "Regeln",
      "edit": "Regel bearbeiten",
      "add": "Neue Regel"
    }
  },
  "rules": {
    "text_ignore": {
      "preview_single_with_url": "\"{{text_ignore}}\" wird im Inhalt und in der URL ignoriert",
      "preview_single": "\"{{text_ignore}}\" wird im Inhalt ignoriert",
      "preview_more_with_url": "\"{{text_ignore}}\" and {{count}} mehr wird im Inhalt ignoriert",
      "preview_more": "\"{{text_ignore}}\" und {{count}} mehr werden im Inhalt ignoriert",
      "other_parameters": "Für diese Regel sind weitere Parameter eingestellt, klicken Sie auf die Schaltfläche \"Bearbeiten\", um weitere Informationen zu erhalten"
    },
    "text_replace": {
      "preview_single_with_url": "\"{{original}}\" wird im Inhalt durch \"{{replacement}}\" ersetzt und die URLs",
      "preview_single": "\"{{original}}\" wird im Inhalt durch \"{{replacement}}\" ersetzt",
      "preview_more_with_url": "\"{{original}}\" wird im Inhalt und in den URLs durch \"{{replacement}}\" ersetzt, und {{nb}} mehr",
      "preview_more": "\"{{original}}\" wird im Inhalt durch \"{{replacement}}\" ersetzt, und {{nb}} mehr",
      "other_parameters": "Für diese Regel sind weitere Parameter eingestellt, klicken Sie auf die Schaltfläche \"Bearbeiten\", um weitere Informationen zu erhalten"
    },
    "content_exclusion": {
      "selectors": "{{nb}} CSS-Selektor(en) von der Übersetzung ausgeschlossen",
      "other_parameters": "Für diese Regel sind weitere Parameter eingestellt, klicken Sie auf die Schaltfläche \"Bearbeiten\", um weitere Informationen zu erhalten"
    },
    "url_exclusion": {
      "some_multilingual": "{{nb}} URLs werden von der Übersetzung ausgeschlossen, behalten aber trotzdem das mehrsprachige Präfix",
      "some": "{{nb}} URLs sind komplett von der Übersetzung ausgeschlossen",
      "all_multilingual": "alle URLs werden von der Übersetzung ausgeschlossen, behalten aber trotzdem das mehrsprachige Präfix",
      "all": "alle URLs werden komplett von der Übersetzung ausgeschlossen",
      "other_parameters": "Für diese Regel sind weitere Parameter eingestellt, klicken Sie auf die Schaltfläche \"Bearbeiten\", um weitere Informationen zu erhalten"
    },
    "ignore_inline": {
      "elements": "Alle Inline-Inhalte werden als Blockinhalte auf der Seite übersetzt",
      "all_elements": "Einige Inline-Inhalte werden als Blockinhalte auf der Seite übersetzt",
      "other_parameters": "Für diese Regel wurden weitere Parameter festgelegt. Klicken Sie auf die Schaltfläche „Bearbeiten“, um weitere Informationen zu erhalten."
    },
    "title": "Regelverwaltung",
    "description": "Verwalten Sie den Ausschluss von Übersetzungen und die Ersetzung von Inhalten auf Ihrer gesamten Website",
    "add": "Neue Regel hinzufügen",
    "table": {
      "title": "Titel",
      "type": "Typ",
      "preview": "Regelvorschau",
      "action": "Aktion",
      "delete_confirm": "Bitte bestätigen Sie das Löschen der Regel",
      "types": {
        "text_ignore": "Text ignorieren",
        "text_replace": "Textersetzung",
        "content_exclusion": "Ausschluss von Inhalten",
        "url_exclusion": "URL Ausschluss",
        "ignore_inline": "Inline ignorieren",
        "unknown": "Unbekannte Regel"
      },
      "no_data": "Hier gibt es noch keine Regeln"
    },
    "apply_on_content": {
      "static": "Diese Regel gilt nur für statische Inhalte.",
      "dynamic": "Diese Regel gilt nur für dynamische Inhalte."
    }
  },
  "search_translations": {
    "title": "Verwaltung von Suchübersetzungen",
    "description": "Listen Sie alle Ihre Website-Übersetzungen auf, die über Suchformulare verwendet wurden (von der übersetzten Sprache in Ihre Domain-Basissprache)",
    "filter_languages": "Nach Sprachen filtern...",
    "filter_original": "Text in Originalsprache filtern",
    "filter_translation": "Nach übersetztem Text filtern",
    "table": {
      "original": "Original",
      "language": "Sprache",
      "translation": "Übersetzung"
    }
  },
  "subscription": {
    "failure": {
      "tab_title": "Das Abonnieren ist fehlgeschlagen!",
      "title": "Das Abonnieren ist fehlgeschlagen!",
      "subtitle": "Beim Versuch, Ihr Abonnement zu bearbeiten, ist ein Fehler aufgetreten.",
      "home": "Geh zurück nach Hause",
      "generic": "Auf Linguise-Seite ist ein unbekannter Fehler aufgetreten. Bitte wenden Sie sich an den Administrator!"
    },
    "success": {
      "home": "Domain-Übersetzungen verwalten",
      "message": "Wir sind bestrebt, Ihnen das bestmögliche Übersetzungserlebnis zu bieten. Unser Expertenteam steht Ihnen bei Fragen oder Unterstützung gerne zur Verfügung. Um zu beginnen, klicken Sie einfach auf die Schaltfläche unten.",
      "subtitle": "Vielen Dank, dass Sie sich für den Übersetzungsdienst Linguise entschieden haben",
      "title": "Abonnement aktiviert!",
      "tab_title": "Danke fürs Abonnement!"
    }
  },
  "subscriptions": {
    "edit": {
      "title": "Abonnement verwalten"
    },
    "list": {
      "title": "Liste der Abonnements",
      "description": "Liste Ihrer Domain-Abonnements"
    },
    "table": {
      "domain": "Domain",
      "plan": "Plan",
      "status": "Status",
      "card": "Karte",
      "usage": "Verwendung",
      "actions": "Aktionen",
      "payment_method": "Zahlungsmethode"
    },
    "usage": {
      "paid": "{{words_used}} / {{words_allowed}} wörter",
      "paidOffered": "{{words_used}} / {{words_allowed}} wörter\n(Enthalten {{free_words}} angebotene wörter)"
    },
    "success": {
      "tab_title": "Abonnement aktiviert!",
      "title": "Abonnement aktiviert!",
      "subtitle": "Vielen Dank, dass Sie sich für den Übersetzungsdienst Linguise entschieden haben",
      "message": "„Wir sind bestrebt, Ihnen das bestmögliche Übersetzungserlebnis zu bieten.“ Unser Expertenteam steht Ihnen bei Fragen oder Unterstützung gerne zur Verfügung. Um zu beginnen, klicken Sie einfach auf die Schaltfläche unten.",
      "home": "Domain-Übersetzungen verwalten"
    },
    "popup": {
      "dueToday": "Gesamtbetrag heute fällig",
      "nextPeriod": "Ab dem {{date}}"
    }
  },
  "topbar": {
    "accounts": {
      "choose": "Wähle einen Account"
    }
  },
  "translation": {
    "main": {
      "parent": "Übersetzungen",
      "edit": "Übersetzung bearbeiten"
    },
    "form": {
      "original": {
        "title": "Original auf {{language}}"
      },
      "is_inline": "Diese Übersetzung wird aus Inline-Inhalten erstellt.",
      "inline_editor": {
        "count_warning": "Die Anzahl der Inline-Bereiche stimmt nicht mit dem Original überein ({{current}} von {{expected}}).",
        "restore_original": "Originaltext wiederherstellen",
        "insert_placeholder": "Platzhalter einfügen",
        "drag": "Inline-Bereich zum Ändern der Reihenfolge ziehen",
        "area": "Inline-Bereich {{index}}",
        "restore": "Fehlende Inline-Bereiche wiederherstellen"
      },
      "translation": {
        "title": "Übersetzung in {{language}}",
        "description": "Übersetzung, die Sie außer Kraft setzen wollen"
      }
    },
    "copy": {
      "title": "In die manuelle Übersetzung kopieren",
      "label": "In Manuell kopieren"
    },
    "level": {
      "base": {
        "title": "Basisübersetzung",
        "subtitle": "Automatisch · Linguise Cloud-Übersetzung",
        "empty": "Keine Basisübersetzung für diesen Text.",
        "overridden": "Ihre Auswahl ist gespeichert, aber stattdessen wird die neueste KI-optimierte Übersetzung angezeigt, da „Manuelle und ausgewählte Übersetzungen überschreiben“ in den KI-Übersetzungseinstellungen auf „Ja“ steht. Deaktivieren Sie diese Einstellung, um Ihre Auswahl zu verwenden."
      },
      "not_generated": "Nicht erzeugt",
      "none": "Noch nichts",
      "ai": {
        "title": "KI-optimierte Übersetzung",
        "subtitle": "Automatisch · Linguise AI",
        "empty_title": "Für diesen Text noch nicht erzeugt",
        "empty_description": "Linguise AI liefert natürlichere Übersetzungen, indem es den Kontext Ihrer Seite und Website berücksichtigt. So erhalten Sie hier eine:",
        "empty_step_1": "Gehen Sie zu KI-Übersetzung › Einstellungen und setzen Sie KI-Übersetzung aktivieren auf „Nur Regeln“, „Nur Live-Editor“ oder „Regeln und Live-Editor“.",
        "empty_step_2": "Wenden Sie sie über eine Regel an, die zu dieser Seite passt, oder aktivieren Sie sie Seite für Seite im Live-Editor.",
        "empty_step_3": "Die KI-optimierte Übersetzung erscheint hier, sobald sie erzeugt wurde. Dabei werden Ihre KI-Guthaben verbraucht.",
        "open_settings": "KI-Übersetzungseinstellungen öffnen",
        "open_editor": "Live-Editor öffnen",
        "overrides_selection": "Ihre Auswahl ist gespeichert, aber stattdessen wird diese KI-optimierte Übersetzung angezeigt, da „Manuelle und ausgewählte Übersetzungen überschreiben“ in den KI-Übersetzungseinstellungen auf „Ja“ steht. Deaktivieren Sie diese Einstellung, um Ihre Auswahl zu verwenden.",
        "overrides_version": "Die von Ihnen gewählte Version ist gespeichert, aber stattdessen wird die neueste KI-optimierte Version angezeigt, da „Manuelle und ausgewählte Übersetzungen überschreiben“ in den KI-Übersetzungseinstellungen auf „Ja“ steht. Deaktivieren Sie diese Einstellung, um die gewählte Version zu verwenden."
      },
      "manual": {
        "title": "Manuelle Übersetzung",
        "subtitle": "Von Ihnen verfasst · hat Vorrang vor automatischen Übersetzungen",
        "empty": "Leer",
        "saved_but_overridden": "Als Ihre Auswahl gespeichert, wird aber nicht automatisch angezeigt, da „Manuelle Übersetzungen überschreiben“ in den KI-Übersetzungseinstellungen auf „Ja“ steht: Die KI-optimierte Übersetzung hat Vorrang, bis diese Einstellung deaktiviert wird.",
        "ignored": "Wird nicht automatisch angezeigt, da „Manuelle Übersetzungen überschreiben“ in den KI-Übersetzungseinstellungen auf „Ja“ steht. Wählen Sie sie aus, um sie für diesen Text zu verwenden.",
        "label": "Ihre Übersetzung",
        "placeholder": "Geben Sie Ihre eigene Übersetzung ein ...",
        "last_updated": "Zuletzt bearbeitet am {{date}}",
        "save_hint": "Beim Speichern wird die manuelle Übersetzung aktiv.",
        "delete": "Manuelle Übersetzung löschen",
        "delete_confirm": "Bitte bestätigen Sie das Löschen der manuellen Übersetzung"
      }
    },
    "history": {
      "title": "KI-optimierte Versionen",
      "subtitle": "Jede Neuerzeugung im Live-Editor wird aufbewahrt",
      "unknown_model": "Unbekanntes Modell",
      "current": "Aktuell",
      "restore": "Diese Version wiederherstellen",
      "restore_note": "Beim Wiederherstellen wird diese Version zur aktuellen KI-optimierten Übersetzung. Es wird nichts gelöscht.",
      "version_of": "Version {{current}} von {{total}}",
      "hide": "Verlauf ausblenden ({{total}})",
      "show": "Verlauf anzeigen ({{total}})"
    },
    "choose": {
      "title": "Übersetzungen auf {{language}} · wählen Sie, welche Besucher sehen",
      "current": "Aktuell auf Ihrer Website:",
      "priority": "Standardpriorität: Manuell › KI-optimiert › Basis. Ihre Auswahl gilt nur für diese Übersetzung.",
      "reset": "Auf Standardpriorität zurücksetzen",
      "reset_title": "Ihre Auswahl für diesen Text verwerfen und wieder die Standardpriorität verwenden",
      "resetting": "Wird zurückgesetzt ..."
    }
  },
  "translations": {
    "title": "Verwaltung von Übersetzungen",
    "description": "Auflisten und Bearbeiten aller Übersetzungen Ihrer Website, für eine visuelle Übersetzung verwenden Sie den Live-Editor",
    "filter_languages": "Nach Sprachen filtern...",
    "filter_original": "Text in Originalsprache filtern",
    "filter_translation": "Nach übersetztem Text filtern",
    "table": {
      "original": "Original",
      "language": "Sprache",
      "action": "Aktion",
      "base": "Basis",
      "ai": "KI-optimiert",
      "manual": "Manuell"
    },
    "filter_exact": "Genaue Übereinstimmung",
    "badge": {
      "active": "Aktiv",
      "overrides_manual": "Überschreibt manuell"
    },
    "cell": {
      "none": "keine",
      "not_generated": "nicht erzeugt",
      "ignored": "Ignoriert – KI-Regel gewinnt"
    },
    "tabs": {
      "all": "Alle",
      "manual": "Mit manuell",
      "ai": "Mit KI-optimiert",
      "base": "Nur Basis"
    },
    "levels_hint": "Jeder Text hat bis zu 3 Ebenen – die als Aktiv markierte sehen Besucher."
  },
  "url": {
    "main": {
      "parent": "URLs",
      "edit": "URL-Übersetzung bearbeiten"
    },
    "form": {
      "original": {
        "title": "Original auf {{language}}"
      },
      "translation": {
        "title": "URL Übersetzung in {{language}}",
        "description": "URL, die überschrieben werden soll",
        "placeholder": "URL-Übersetzung außer Kraft setzen",
        "invalid_full": "Sie versuchen, mit einem falschen Format zu ändern. Sie sollten nur die Slugs/Pfadnamen der URL-Übersetzung ändern",
        "invalid": "Ungültige URL/Pfad angegeben"
      }
    }
  },
  "urls": {
    "title": "URLs-Verwaltung",
    "description": "Auflisten und Bearbeiten aller URLs Ihrer Website mit übersetztem Inhalt (fortgeschritten, Vorsicht vor 404-Fehlern)",
    "filter_languages": "Nach Sprachen filtern...",
    "filter_original": "Text in Originalsprache filtern",
    "filter_translation": "Nach übersetztem Text filtern",
    "table": {
      "original": "Original",
      "language": "Sprache",
      "url": "Übersetzte URL",
      "action": "Aktion",
      "edited": "Die Originalübersetzung wurde bearbeitet"
    }
  }
}
